import tooltip from './grid.tooltip'

export default {
  name: "grid",
  nickname: "网格",
  desc: "grid",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示直角坐标系网格。",
      value: false,
      defaultValue: false,
    },
    zlevel: {
      name: "zlevel",
      nickname: "图形z水平",
      desc: "所有图形的 zlevel 值。",
      value: 0,
      defaultValue: 0,
    },
    z: {
      name: "z",
      nickname: "z",
      desc:
        '组件的所有图形的<code class="codespan">z</code>值。控制图形的前后顺序。<code class="codespan">z</code>值小的图形会被<code class="codespan">z</code>值大的图形覆盖。',
      value: 2,
      defaultValue: 2,
      type: "pureValue",
    },
    left: {
      name: "left",
      nickname: "位置左",
      desc: "grid 组件离容器左侧的距离。",
      value: "10%",
      defaultValue: "10%",
      type: "pureValue",
    },
    top: {
      name: "top",
      nickname: "位置上",
      desc: "grid 组件离容器上侧的距离。",
      value: 60,
      defaultValue: 60,
      type: "pureValue",
    },
    right: {
      name: "right",
      nickname: "位置右",
      desc: "grid 组件离容器右侧的距离。",
      value: "10%",
      defaultValue: "10%",
      type: "pureValue",
    },
    bottom: {
      name: "bottom",
      nickname: "位置下",
      desc: "grid 组件离容器下侧的距离。",
      value: 60,
      defaultValue: 60,
      type: "pureValue",
    },
    width: {
      name: "width",
      nickname: "宽度",
      desc: "grid 组件的宽度。默认自适应。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    height: {
      name: "height",
      nickname: "高度",
      desc: "grid 组件的高度。默认自适应。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    containLabel: {
      name: "containLabel",
      nickname: "containLabel",
      desc:
        'grid 区域是否包含坐标轴的<a target="__blank" href="https://echarts.apache.org/zh/option.html#yAxis.axisLabel">刻度标签</a>。',
      value: false,
      defaultValue: false,
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc: "网格背景色，默认透明。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "网格的边框颜色。支持的颜色格式同 backgroundColor。",
      value: "#ccc",
      defaultValue: "#ccc",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "网格的边框线宽。",
      value: 1,
      defaultValue: 1,
      type: "pureValue",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    tooltip,
  },
  isExpandForce: true,
  menuIconType: "text",
  menuIcon: "WG",
}
